import { cn } from '@/shadcn/lib/utils';

interface Props {
    className?: string | string[];
    src: string;
    alt?: string;
    /** Default lazy. Above-the-fold obrazky (logo v hero) davaj eager, inak dobiehaju az za JS chunkmi. */
    loading?: 'lazy' | 'eager';
    fetchPriority?: 'high' | 'low' | 'auto';
    style?: Record<string, string>;
}

export function Img(props: Props) {
    return (
        <img
            className={cn(props.className)}
            src={props.src}
            alt={props.alt ?? ''}
            loading={props.loading ?? 'lazy'}
            fetchPriority={props.fetchPriority}
            style={props.style || {}}
        />
    );
}
